import React from "react";
import { withRouter } from "react-router-dom";
import OliverHelper from "../../utils/Oliverhelper";
import "../Styling/privacyPolicy.css"; // Assuming you have a CSS file for styles

class PoliticasDePrivacidad extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [],
      contact: { nombre: "", email: "", telefono: "", mensaje: "" },
      bannersFooter: [],
    };
  }

  componentDidMount() {
    document.title = "Vende tu terreno o casa";
    OliverHelper.ClientAPI.getProjects().then((response) => {
      this.setState({ projects: response.emprendimientos });
    });
    OliverHelper.ClientAPI.getProjects({ home_top_slider: 1 }).then(
      (response) => {
        this.setState({ bannersFooter: response.bannersFooter });
      }
    );
  }

  render() {
    return (
      <div className="privacy-policy">
        <h1 className="title">Política de Privacidad</h1>
        <p className="updated">Última actualización: 23 de mayo de 2025</p>

        <h2 className="section-title">
          1. Responsable del tratamiento de los datos
        </h2>
        <p>
          <strong>PBG Desarrollos S.R.L.</strong>
          <br />
          Domicilio: Av. del Libertador 5936 12° B<br />
          Email de contacto: contacto@pbgdesarrollos.com.ar
        </p>

        <h2 className="section-title">2. Datos que recopilamos</h2>
        <p>
          Podemos recopilar los siguientes datos personales a través de
          formularios de contacto, suscripción o consultas:
        </p>
        <ul>
          <li>Nombre y apellido</li>
          <li>Dirección de correo electrónico</li>
          <li>Número de teléfono</li>
          <li>
            Información adicional proporcionada voluntariamente por el usuario
          </li>
        </ul>

        <h2 className="section-title">3. Finalidad del tratamiento</h2>
        <p>Los datos son utilizados con las siguientes finalidades:</p>
        <ul>
          <li>Atender consultas o solicitudes enviadas por el usuario</li>
          <li>
            Enviar información comercial sobre nuestros desarrollos
            inmobiliarios, promociones o eventos (si el usuario lo autoriza)
          </li>
          <li>
            Mejorar nuestros servicios y la experiencia del usuario en el sitio
            web
          </li>
        </ul>

        <h2 className="section-title">4. Cesión de datos a terceros</h2>
        <p>
          Los datos personales no serán cedidos, vendidos ni compartidos con
          terceros, salvo obligación legal o que el usuario haya prestado su
          consentimiento expreso.
        </p>

        <h2 className="section-title">5. Derechos del titular de los datos</h2>
        <p>El titular de los datos personales tiene derecho a:</p>
        <ul>
          <li>Acceder a sus datos</li>
          <li>Rectificarlos</li>
          <li>Actualizarlos</li>
          <li>Suprimirlos, si correspondiera</li>
          <li>Revocar el consentimiento prestado</li>
        </ul>
        <p>
          Para ejercer estos derechos, el usuario puede comunicarse a través del
          correo electrónico mencionado anteriormente.
        </p>

        <h2 className="section-title">6. Seguridad</h2>
        <p>
          Adoptamos medidas técnicas y organizativas para proteger los datos
          personales contra pérdida, mal uso, acceso no autorizado, alteración o
          destrucción.
        </p>

        <h2 className="section-title">7. Cookies</h2>
        <p>
          Este sitio puede utilizar cookies para mejorar la navegación del
          usuario. El uso de cookies puede ser aceptado o rechazado por el
          usuario desde su navegador.
        </p>

        <h2 className="section-title">8. Transferencias internacionales</h2>
        <p>
          En caso de utilizar servicios de terceros ubicados fuera de Argentina
          (por ejemplo, servidores o plataformas de email marketing), nos
          aseguramos de que se cumpla con un nivel adecuado de protección de
          datos, conforme a la normativa vigente.
        </p>

        <h2 className="section-title">9. Autoridad de control</h2>
        <p>
          La Agencia de Acceso a la Información Pública, órgano de control de la
          Ley N° 25.326, tiene la atribución de atender denuncias y reclamos
          relacionados con el incumplimiento de las normas sobre protección de
          datos personales.
        </p>
        <p>
          El titular de los datos personales tiene la facultad de ejercer el
          derecho de acceso a los mismos en forma gratuita a intervalos no
          inferiores a seis meses, salvo que se acredite un interés legítimo al
          efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley
          N° 25.326.
        </p>
        <p>
          La AGENCIA DE ACCESO A LA INFORMACIÓN PÚBLICA tiene la atribución de
          atender las denuncias y reclamos que se interpongan con relación al
          incumplimiento de las normas sobre protección de datos personales.
        </p>
      </div>
    );
  }
}

export default withRouter(PoliticasDePrivacidad);
